var types = ["success", "info", "warning", "danger"];
/* Notification styles that use same colors as theme from material ui */

var notificationsStyle = function notificationsStyle(theme, type) {
  var paletteColors = theme.palette[type === "danger" ? "error" : type];
  return "\n.rnc__notification-item--".concat(type, " {\n    background-color: ").concat(paletteColors.main, ";\n    border-left: 8px solid ").concat(paletteColors.dark, ";\n}\n.rnc__notification-item--").concat(type, " .rnc__notification-timer {\n    background-color: ").concat(paletteColors.main, ";\n}\n.rnc__notification-item--").concat(type, " .rnc__notification-close-mark {\n    background-color: ").concat(paletteColors.main, ";\n}\n\n");
};

var notificationsStyles = function notificationsStyles(theme) {
  return ".rnc__base {".concat(types.map(function (type) {
    return notificationsStyle(theme, type);
  }).join(""), "}\n");
};

export { notificationsStyles as default };